import { render, staticRenderFns } from "./AddParceiro.vue?vue&type=template&id=50bc6391&scoped=true"
import script from "./AddParceiro.vue?vue&type=script&lang=js"
export * from "./AddParceiro.vue?vue&type=script&lang=js"
import style0 from "./AddParceiro.vue?vue&type=style&index=0&id=50bc6391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc6391",
  null
  
)

export default component.exports